import farmWorkRecord from '@/api/modules/productManage/farmWorkRecord'

export default {
  createFarmland: { // 创建地块
    url: '/api/createFarmland',
    method: 'post'
  },
  getFarmland: { // 查询地块
    url: '/api/getFarmland',
    method: 'get'
  },
  getFarmlandList: { // 查询地块列表
    url: '/api/getFarmlandList',
    method: 'get'
  },
  updateFarmland: { // 修改地块
    url: '/api/updateFarmland',
    method: 'put'
  },
  deleteFarmland: { // 删除地块
    url: '/api/deleteFarmland',
    method: 'delete'
  },
  createControlCropBreed: { // 添加种养品种
    url: '/api/createControlCropBreed',
    method: 'post'
  },
  getControlCropBreedList: { // 查询种养品种列表
    url: '/api/getControlCropBreedList',
    method: 'get'
  },
  deleteControlCropBreed: { // 删除种养品种
    url: '/api/deleteControlCropBreed',
    method: 'delete'
  },
  createControlPick: { // 添加采摘记录
    url: '/api/createControlPick',
    method: 'post'
  },
  getControlPickList: { // 查询采摘记录列表
    url: '/api/getControlPickList',
    method: 'get'
  },
  deleteControlPick: { // 删除采摘记录
    url: '/api/deleteControlPick',
    method: 'delete'
  },
  createInspectReport: { // 添加检测报告
    url: '/api/createInspectReport',
    method: 'post'
  },
  getInspectReportList: { // 查询检测报告列表
    url: '/api/getInspectReportList',
    method: 'get'
  },
  updateInspectReport: { // 修改检测报告
    url: '/api/updateInspectReport',
    method: 'put'
  },
  deleteInspectReport: { // 删除检测报告
    url: '/api/deleteInspectReport',
    method: 'delete'
  },
  updateControlCropBreed: { // 修改种养品种
    url: '/api/updateControlCropBreed',
    method: 'put'
  },
  finishCropBreed: {
    url: '/api/finishCropBreed',
    method: 'put'
  },
  // 农事记录
  ...farmWorkRecord
}
